import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";
import { buildPaginatedUrl } from "@/lib/api/utils";

const BASE = "/discussions";

export const discussionsApi = {
  list: (params?: PaginatedParams & { category?: string; tags?: string[] }) => {
    const extraParams: Record<string, string | string[]> = {};
    if (params?.tags?.length) extraParams.tags = params.tags;
    return apiGet<PaginatedResponse<Record<string, unknown>>>(
      buildPaginatedUrl(BASE, params, extraParams)
    );
  },

  getById: (id: string) => apiGet<{ discussion: Record<string, unknown> }>(`${BASE}/${id}`),

  create: (data: Record<string, unknown>) => apiPost<{ discussion: Record<string, unknown> }>(BASE, data),

  update: (id: string, data: Record<string, unknown>) =>
    apiPut<{ discussion: Record<string, unknown> }>(`${BASE}/${id}`, data),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  addReply: (id: string, content: string) =>
    apiPost<{ reply: Record<string, unknown> }>(`${BASE}/${id}/replies`, { content }),

  deleteReply: (discussionId: string, replyId: string) =>
    apiDelete<{ message: string }>(`${BASE}/${discussionId}/replies/${replyId}`),

  upvote: (id: string) => apiPost<{ discussion: Record<string, unknown> }>(`${BASE}/${id}/upvote`),

  downvote: (id: string) => apiPost<{ discussion: Record<string, unknown> }>(`${BASE}/${id}/downvote`),

  upvoteReply: (discussionId: string, replyId: string) =>
    apiPost<{ reply: Record<string, unknown> }>(`${BASE}/${discussionId}/replies/${replyId}/upvote`),
};
